import PropTypes from 'prop-types';
import styled from 'styled-components';

import devices from '@/utilities/devices';

const ButtonContainer = styled.div`
	align-items: center;
	display: flex;
	justify-content: center;
	text-align: center;
	user-select: none;
	a {
		border-radius: 40px;
		background-color: ${({ version, theme }) => {
			switch (version) {
				case 'whiteTransparent':
					return theme.color.transparent;
				case 'blackWhite':
					return theme.color.white;
				case 'redWhite':
					return theme.color.white;
				case 'whiteRed':
					return theme.color.red;
			}
		}};
		border: 2px solid ${({ version, theme }) => {
			switch (version) {
				case 'whiteTransparent':
					return theme.color.white;
				case 'blackWhite':
					return theme.color.grey;
				case 'redWhite':
					return theme.color.white;
				case 'whiteRed':
					return theme.color.red;
			}
		}};
		filter: drop-shadow(${({ version, theme }) => {
			switch (version) {
				case 'whiteTransparent':
					return `0rem .2rem .2rem ${theme.color.transparent}`;
				case 'blackWhite':
					return `0rem .2rem .2rem rgba(${theme.color.rgbWhite}, .4)`;
				case 'redWhite':
					return `0rem .2rem .2rem rgba(${theme.color.rgbWhite}, .4)`;
				case 'whiteRed':
					return `0rem .2rem .2rem rgba(${theme.color.rgbRed}, .4)`;
			}
		}});
		color: ${({ version, theme }) => {
			switch (version) {
				case 'whiteTransparent':
					return theme.color.white;
				case 'blackWhite':
					return theme.color.black;
				case 'redWhite':
					return theme.color.red;
				case 'whiteRed':
					return theme.color.white;
			}
		}};
		display: inline-block;
		font-size: ${props => props.fontSize};
		font-weight: 700;
		letter-spacing: 1px;
		outline: 0;
		padding: .5rem 1rem .5rem;
		text-decoration: none;
		text-transform: uppercase;
		transition: .3s;
		white-space: nowrap;
		width: ${props => props.width};

		:hover {
			background-color: ${props => {
				switch (props.version) {
					case 'whiteTransparent':
						return props.theme.color.red;
					case 'blackWhite':
						return props.theme.color.greyLight;
					case 'redWhite':
						return props.theme.color.red;
					case 'whiteRed':
						return props.theme.color.white;
				}
			}};
			border: 2px solid ${props => {
				switch (props.version) {
					case 'whiteTransparent':
						return props.theme.color.red;
					case 'blackWhite':
						return props.theme.color.grey;
					case 'redWhite':
						return props.theme.color.white;
					case 'whiteRed':
						return props.theme.color.red;
				}
			}};
			color: ${props => {
				switch (props.version) {
					case 'whiteTransparent':
						return props.theme.color.white;
					case 'blackWhite':
						return props.theme.color.black;
					case 'redWhite':
						return props.theme.color.white;
					case 'whiteRed':
						return props.theme.color.red;
				}
			}};
		}
		@media screen and (${devices.mobile}) {
			font-size: ${({theme}) => theme.fontSize.XSMALL};
			margin-bottom: 4em;
		}
		@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
			font-size: ${({theme}) => theme.fontSize.XSMALL};
		}
		@media screen and (${devices.minLaptop}) and (${devices.maxLaptop}) {
			font-size: ${({theme}) => theme.fontSize.XSMALL};
		}
	}

	@media screen and (${devices.mobile}) {
		display: block;
		margin: auto;
		padding: 1em 0 1.5em;
		text-align: center;
		width: auto;
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		display: block;
		margin: auto;
		padding: 1em 0 1.7em;
		text-align: center;
		width: 90%;
	}

	svg {
		font-size: 1.1em;
		padding-left: 1em;
	}
`;

const Button = ({ className, children, href, name, width, fontSize, version, onClick, gtm_id, openOnNewTab }) => {
	return (
		<ButtonContainer id={gtm_id} className={className} fontSize={fontSize} version={version} width={width} onClick={onClick}>
			<a href={href} name={name} target={openOnNewTab ? '_blank' : ''} rel="noreferrer"> {name} {children} </a>
		</ButtonContainer>
	);
};

Button.defaultProps = {
	fontSize: '0.75rem',
};

Button.propTypes = {
	children: PropTypes.any,
	className: PropTypes.string,
	href: PropTypes.string,
	name: PropTypes.string.isRequired,
	width: PropTypes.string,
	fontSize: PropTypes.string,
	openOnNewTab: PropTypes.bool,
	version: PropTypes.oneOf(['whiteTransparent', 'blackWhite', 'redWhite', 'whiteRed']),
	onClick: PropTypes.func,
	gtm_id: PropTypes.string,
};

export default Button;
